const forgeUiComponent = require('../framework/ui-component');

const BffLogo = forgeUiComponent('BFFLogo', {
  minimized: 'is-minimized'
});

module.exports = BffLogo;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/bfflogo.js
// module id = 126
// module chunks = 0